/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
export class FrontEndConfig{
  apiBaseUrl: string;
  apiUrl:string;
  preservationDays:number;
  enableTax:string;
  azureAd: AzureAdConfig;
}

export class AzureAdConfig {
  clientId: string;
  tenant:string;
  endpoints:any;
}
